module.exports = __webpack_public_path__ + "static/media/sun.d66538d5.svg";